import * as actionTypes from "./actionTypes";

//bi fetched
export const fetchIIbCount = (payload) => {
  // console.log("payload", payload);
  return {
    type: actionTypes.IIBCOUNT,
    formData: payload,
  };
};
